import React from "react";
import AppModal from "../common/AppModal";
import CreateOrUpdateAccountForm from "../../forms/CreateOrUpdateAccountForm";
import { AccountResponseDto } from "../../shared/dtos/account/AccountResponseDto";

interface UpdateAccountModalProps {
  open: boolean;
  onClose: () => void;
  account: AccountResponseDto;
  loading: boolean;
  error: string | null;
}

const UpdateAccountModal: React.FC<UpdateAccountModalProps> = ({
  open,
  onClose,
  account,
  loading,
  error,
}) => (
  <AppModal
    open={open}
    onClose={onClose}
    title={`Edit Account: ${account.name}`}
    width="md"
    loading={loading}
  >
    <CreateOrUpdateAccountForm
      isEditing={true}
      account={account}
      loading={loading}
      error={error}
    />
  </AppModal>
);

export default UpdateAccountModal;
